import { createUseStyles } from 'react-jss'

export default createUseStyles({
  baseList: {
    listStyle: 'none',
    padding: 0,
    width: '100%'
  },
  listItem: {
    fontWeight: '700',
    padding: '10px 0',
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    '--icon__primary__stroke__color': 'var(--tips__text)',
    marginRight: '10px'
  }
})
